import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import SelectInput from "../Builder/nodes/Logic/Inputs/SelectInput";
import { useLazyGetProjectsQuery } from "../store/slices/projectsAPISlice";

export default function CustomReportsProjectPickerModal({ show, onHide, onSelect, config }) {
  const [title, setTitle] = useState("Project Processes");
  const [displayMode, setDisplayMode] = useState("table");
  const [selectedProjectId, setSelectedProjectId] = useState([]);
  const [projects, setProjects] = useState([]);
  const [getProjects, { isFetching }] = useLazyGetProjectsQuery();

  const loadProjects = async (search = "", previousOptions = []) => {
    const response = await getProjects({
      label: search,
      limit: 50,
      offset: previousOptions.length,
    });
    const data = response.data || { projects: [], total: 0 };
    const options = (data.projects || []).map((project) => ({
      value: project.ID,
      label: project.Label,
      project,
    }));
    setProjects((current) => [...current, ...options]);

    return {
      options,
      hasMore: previousOptions.length + options.length < (data.total || 0),
    };
  };

  useEffect(() => {
    if (show) {
      setTitle(config?.title || "Project Processes");
      setDisplayMode(config?.displayMode || "table");
      setSelectedProjectId(config?.projectId ? [config.projectId] : [""]);
      setProjects(config?.projectId ? [{ value: config.projectId, label: config.projectLabel, project: { ID: config.projectId, Label: config.projectLabel } }] : [{ value: "", label: "All processes" }]);
    }
  }, [show, config]);

  const selectedProject = projects.find(
    (option) => option.value === selectedProjectId[0]
  );
  const showingAllProcesses = selectedProjectId[0] === "";

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Select a project</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label htmlFor="project-processes-title" className="form-label">Widget title</label>
          <input
            id="project-processes-title"
            type="text"
            className="form-control"
            value={title}
            onChange={(event) => setTitle(event.target.value)}
            maxLength={100}
          />
        </div>
        <p className="text-secondary">
          Choose the project whose processes should appear in this report.
        </p>
        <div className="mb-3">
          <SelectInput
            value={selectedProjectId}
            onChange={setSelectedProjectId}
            loadOptions={async (search, previousOptions) => {
              const result = await loadProjects(search, previousOptions);
              return {
                ...result,
                options: previousOptions.length ? result.options : [{ value: "", label: "All processes" }, ...result.options],
              };
            }}
            placeholder="Search projects"
            autoFocus
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Display</label>
          <SelectInput
            value={[displayMode]}
            onChange={(values) => setDisplayMode(values[0])}
            options={[
              { value: "table", label: "Table" },
              { value: "count", label: "Count" },
              { value: "pie", label: "Pie chart" },
              { value: "bar", label: "Bar graph" },
            ]}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-light" onClick={onHide}>
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-colored"
          disabled={(!selectedProject && !showingAllProcesses) || !title.trim() || isFetching}
          onClick={() => {
            onSelect(selectedProject ? { ...selectedProject.project, title: title.trim(), displayMode } : { ID: "", Label: "All processes", title: title.trim(), displayMode });
            onHide();
          }}
        >
          Add widget
        </button>
      </Modal.Footer>
    </Modal>
  );
}
